<template>
  <div>
    <div class="content" :style="contentStyle">
      <iframe class="workflow-frame" :src="buildUrl" />
    </div>
    <div class="overlay" />
    <div v-if="!newMxa" class="control-bar">
      <div class="control-buttons">
        <div class="control-button" @click="onClose">
          <i class="icon-check" />
          {{ $t('workflowBuilder_close') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowBuilder',

  props: {
    onClose: Function,
    projectId: {
      type: Number
    },
    workflowId: {
      type: Number
    },
    mxaDomain: {
      type: String
    },
    newMxa: {
      type: Boolean
    }
  },

  computed: {
    buildUrl() {
      return this.newMxa
        ? `https://${this.mxaDomain}/project/${this.projectId}/workflow/${this.workflowId}`
        : `https://${this.mxaDomain}/old/project/${this.projectId}/workflow/${this.workflowId}`
    },
    contentStyle() {
      return { top: this.newMxa ? '0px' : '55px' }
    }
  },

  methods: {
    handleMessage(event) {
      if (
        event.origin === 'https://' + this.mxaDomain &&
        event.data.type === 'mxaClose'
      ) {
        this.onClose()
      }
    }
  },

  mounted() {
    window.addEventListener('message', this.handleMessage)
  },

  beforeUnmount() {
    window.removeEventListener('message', this.handleMessage)
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #32373a;
}
.content {
  position: fixed;
  z-index: 1000001;
  top: 55px;
  left: 0;
  right: 0;
  bottom: 0;
}
.workflow-frame {
  height: 100%;
  width: 100%;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.control-bar {
  position: fixed;
  z-index: 1000002;
  top: 0;
  left: 0;
  right: 0;
  height: 55px;
  background: #505659;
  padding: 0 20px;
}
.control-buttons {
  float: left;
}
.control-button {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  float: left;
  height: 55px;
  line-height: 55px;
  font-size: 14px;
  color: #ffffff;
  padding: 0 5px;
  margin-right: 20px;
}
.control-button:hover {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/common/components/workflow/WorkflowBuilder.vue